import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../core/services';
import { customEmailValidator } from '../../core/utils/custom-email-validator.utils';
import { BrandingService } from '../../core/services/branding.service';
import { TranslateService } from '@ngx-translate/core';
import { PmaService } from '../../pma/pma.service';
import { Observable } from 'rxjs';
import { ApiErrorResponse } from '../../core/models/auth.model';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  isRegisterDisabled$: Observable<string | boolean | null>;

  constructor(
    public brandingService: BrandingService,
    private fb: FormBuilder,
    public authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private translate: TranslateService,
    private pmaService: PmaService,
  ) {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, customEmailValidator()]],
      password: ['', Validators.required],
      remember_me: false
    });
    this.isRegisterDisabled$ = brandingService.isRegisterDisabled$;
  }

  ngOnInit(): void {
    this.brandingService.setBrandingTitle('Login');
  }

  onSubmit(): void {
    if (!this.loginForm.valid) {
      this.toastr.error(this.translate.instant('form.please_fill_the_form'));
      return;
    }

    this.authService.login(this.loginForm.value).subscribe(() => {
      const params = this.route.snapshot.queryParams;
      if (params && params['renewal_token']) {
        this.router.navigate([`user/policies/view/${params['policy_id']}`], { queryParams: { renewal_token: params['renewal_token'] }});
      } else if (params?.['returnTo']) {
        const prepopulate = typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('amtrust_return_prepopulate') : null;
        sessionStorage.removeItem('amtrust_return_prepopulate');
        this.pmaService.redirectToAmtrustApp({
          ...(prepopulate ? { prepopulate } : {}),
          parentUrl: window.location.origin,
          amtrustClientUrl: this.brandingService.getAmtrustClientUrlSnapshot(),
        });
      } else {
        this.router.navigate(['/user/profile']);
      }
    },
    (errors: ApiErrorResponse) => {
      if (errors.errors && Array.isArray(errors.errors)) {
        errors.errors.forEach(message => this.toastr.error(message));
      }
    });
  }
}
